import type {ValueInstanceFragment} from "app/gql/graphqlSchema";
import {isNil} from "app/utils/stdlib";

export const useHasControlCardValueError = (valueInstance: ValueInstanceFragment) => {
  return (
    valueInstance.validationResult.__typename === "ErrorValidationResult" &&
    !valueInstance.validationResult.initial &&
    isNil(valueInstance.overriddenValidationResult)
  );
};
